import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ptmAccountApi from "./api";

const initialState = {
  isLoading: false,
  ptmEmployers: [],
  singleEmployer: null,

  signedUrlData: null,
  signedUrlLoading: false,
  signedUrlError: null,
  createError: null,
  updateError: null,
  pagination: {
  page: 1,
  total: 0,
  limit: 10,
},
};

export const listEmployersAccounts = createAsyncThunk(
  "/ptm/ptmsAccounts",
  async (values, thunk) => {
    try {
      const response = await ptmAccountApi.listAccount(values);
      return response.data;
    } catch (error) {
      return thunk.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getSingleEmployerAccount = createAsyncThunk(
  "/ptm/ptmsAccounts/single",
  async ({id,callBack}, thunk) => {
    try {
      const response = await ptmAccountApi.getSingleAccount(id);
      console.log("Single Employer Response:", response);
      if(response.status === 200){
        callBack(response)
      }
      return response.data;
    } catch (error) {
      return thunk.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const generateSignedUrl = createAsyncThunk(
  "ptmAccounts/generateSignedUrl",
  async (payload, thunk) => {
    try {
      const response = await ptmAccountApi.getSignedUrl(payload);
      return response.data;
    } catch (error) {
      return thunk.rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const createEmployerAccount = createAsyncThunk(
  "ptmAccounts/createEmployerAccount",
  async (payload, thunk) => {
    try {
      const response = await ptmAccountApi.createAccount(payload);
      if(response.status === 201){
        payload.callBack(response)
      }else throw response;
      return response.data;
    } catch (error) {
      return thunk.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateEmployerAccount = createAsyncThunk(
  "ptmAccounts/updateEmployerAccount",
  async ({ id, payload }, thunk) => {
    try {
      const response = await ptmAccountApi.updateAccount(id, payload);
      return response.data;
    } catch (error) {
      return thunk.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const ptmAccountSlice = createSlice({
  name: "ptmAccounts",
  initialState,
  reducers: {
    clearSignedUrlData: (state) => {
      state.signedUrlData = null;
      state.signedUrlError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // List
      .addCase(listEmployersAccounts.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(listEmployersAccounts.fulfilled, (state, action) => {
  state.isLoading = false;
  state.ptmEmployers = action.payload.data;
  console.log("Payload Pagination:", action.payload);
  state.pagination.page = action.payload.page 
  state.pagination.limit = action.payload.limit 
    state.pagination.total = action.payload.total 
})

      .addCase(listEmployersAccounts.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(getSingleEmployerAccount.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSingleEmployerAccount.fulfilled, (state, action) => {
        state.isLoading = false;
        state.singleEmployer = action.payload;
      })
      .addCase(getSingleEmployerAccount.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(generateSignedUrl.pending, (state) => {
        state.signedUrlLoading = true;
        state.signedUrlError = null;
      })
      .addCase(generateSignedUrl.fulfilled, (state, action) => {
        state.signedUrlLoading = false;
        state.signedUrlData = action.payload;
      })
      .addCase(generateSignedUrl.rejected, (state, action) => {
        state.signedUrlLoading = false;
        state.signedUrlError = action.payload;
      })

      .addCase(createEmployerAccount.pending, (state) => {
        state.isLoading = true;
        state.createError = null;
      })
      .addCase(createEmployerAccount.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(createEmployerAccount.rejected, (state, action) => {
        state.isLoading = false;
        state.createError = action.payload;
      })

      .addCase(updateEmployerAccount.pending, (state) => {
        state.isLoading = true;
        state.updateError = null;
      })
      .addCase(updateEmployerAccount.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateEmployerAccount.rejected, (state, action) => {
        state.isLoading = false;
        state.updateError = action.payload;
      });
  },
});

export const { clearSignedUrlData } = ptmAccountSlice.actions;

export default ptmAccountSlice.reducer;